import { render, staticRenderFns } from "./OtherSvgsModal.vue?vue&type=template&id=ecf71c00&scoped=true&"
import script from "./OtherSvgsModal.vue?vue&type=script&lang=js&"
export * from "./OtherSvgsModal.vue?vue&type=script&lang=js&"
import style0 from "./OtherSvgsModal.vue?vue&type=style&index=0&id=ecf71c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf71c00",
  null
  
)

export default component.exports